import styled from 'styled-components';
import { HistoryGraphContainer } from 'pages/NewOverview/styles';

export const EnergyEfficiencyCardContainer = styled(HistoryGraphContainer)<{ expandedSplit: boolean, order: number }>`
  width: ${({ expandedSplit }) => (expandedSplit ? '50%' : '500px')};
  height: 364px;
  display: flex;
  gap: 14px;
  pointer-events: none;
  position: relative;
  order: ${({ order }) => order};
`;
